module.exports = __webpack_public_path__ + "static/media/main idea.b5f3e709.mp3";